"use client";

import { Box, Typography, Button } from "@mui/material";
import { useRouter } from "next/navigation";

export default function NotFoundPage() {
  const router = useRouter();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        justifyContent: "space-between",
      }}
    >

      {/* Main Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 3,
        }}
      >
        <Typography variant="h1" sx={{ fontSize: "4rem", fontWeight: "bold", mb: 2 }}>
          404
        </Typography>
        <Typography variant="h6" sx={{ mb: 4 }}>
          The page you are looking for does not exist.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => router.push("/")}
          sx={{ textTransform: "none", fontWeight: "600", px: 4, py: 1.5 }}
        >
          Go to Homepage
        </Button>
      </Box>

    </Box>
  );
}
